
































import Vue from 'vue';

export default Vue.extend({
  name: 'BasicGCoinsManagementView',
  computed: {
    activeRouteName(): string {
      return this.$route.name || '';
    },
    tabTitle(): string {
      const activeTabRouteNameSuffix = this.activeRouteName.split('-')[2];
      return this.$t(
        `admin-panel.gcoins.tabs.${activeTabRouteNameSuffix}.name`,
      ) as string;
    },
  },
});
